
import React, { useContext } from "react";
import i18next from "i18next";
import { Grid } from "@mui/material";
import { RuleActionParameterNames, RuleActionType, RulesContext } from "services/common/RulesUtils";
import EAInputBloc from "components/common/EAInputBloc";
import { useFormContext } from "react-hook-form";
import EAMultipleSelectInputCommaSeparated from "components/rules/EAMultipleSelectInputCommaSeparated";
import { isSealedDocument } from "services/common/Constants";
import RuleReverseActionParam from "../RuleReverseActionParam";


const DocumentAddAndRemoveActionParams = ({ actionType, fieldName, readOnly = false }) => {
  const {
    documentTypes,
  } = useContext(RulesContext);

  const formMethods = useFormContext();
  const {
    setValue
  } = formMethods;

  return (
    <Grid container spacing={2} style={{ alignItems: "center", justifyContent: "center" }}>
      <Grid item xs={12} md={8}>
        <EAInputBloc label={i18next.t("rules.configuration.ruleActions.fields.parameters.documentTypeCode.label")}
          customLabelStyle={{ fontSize: "14px" }}>
          <EAMultipleSelectInputCommaSeparated
            fieldName={`${fieldName}.${RuleActionParameterNames.DOCUMENT_TYPE_IDS}`}
            options={documentTypes.filter(doc => !isSealedDocument(doc.code))}
            isRequired
            onChange={(e) => {
              setValue(`${fieldName}.${RuleActionParameterNames.DOCUMENT_TYPE_IDS}`, e.target.value);
            }}
            placeholder={i18next.t(`rules.configuration.ruleActions.fields.parameters.documentTypeCode.placeholder`)}
            disabled={readOnly}
          />
        </EAInputBloc>
      </Grid >
      {
        actionType === RuleActionType.DOCUMENT_ADD && (
          <RuleReverseActionParam fieldName={fieldName} readOnly={readOnly}/>
        )
      }
    </Grid >
  );
}

export default DocumentAddAndRemoveActionParams;
